<template>
    <div id="dashboard-view">
        <teleport to="#sub-nav">
            <div class="button" @click="updateLogs">{{fetching_logs ? 'FETCHING..' : ((logs.length > 0) ? 'UPDATE LOG' : 'FETCH ENTIRE HISTORY')}} </div>
            <div class="button" @click="fetchPlayers">{{fetching_players ? 'FETCHING..' : 'FETCH PLAYERS'}}</div>
            <div class="button" @click="exportData">EXPORT</div>
            <div class="button" @click="toggleSync">{{sync_enabled? 'DISABLE' : 'ENABLE'}}</div>
        </teleport  >

        <table class="main-table gaps">
           
            <thead>
                <th>Timestamp</th>
                <th>Action</th>
                <th>Category</th>
                <th>Details</th>
            </thead>
            <tbody>
                <template  v-for="log in logs" :key="'log' + log.id">
                    <tr class="clear-gaps">
                        <td :title="log.timestamp">{{log.formatted_date}}</td>
                        <td>{{log.title}}</td>
                        <td>{{log.category}}</td>
                        <td class="sub-table-wrapper">
                            <table class="sub-table">
                                <thead>
                                    <th v-for="item_key in Object.keys(log.data).filter(key => !key.includes('_formatted'))" :key="`data-header-${log.id}-${item_key}`">
                                        {{titleCase(item_key.replaceAll('_', ' '))}}
                                    </th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <template v-for="item_key in Object.keys(log.data).filter(key => !key.includes('_formatted'))" :key="`data-column-${log.id}-${item_key}`">
                                            <td v-if="['log', 'reason'].includes(item_key)" v-html="log.data[item_key]" class="log-link">
                                            </td>
                                            <td v-else v-html="log.data[`${item_key}_formatted`]">
                                            </td>
                                        </template>
                                    </tr>
                                </tbody>

                            </table>
                            <!-- <td v-if="log.data?.log" class="log-link" v-html="log.data.log">   </td>
                            <td> TEST </td> -->
                        </td>
                    </tr>
                    <!-- <tr>
                        <td colspan="4" style="height: 5px; padding: 0; background-color: #111;"> </td>
                    </tr> -->
                </template>
            </tbody>
        </table>
    </div>
</template>

<script>
import {toRaw} from 'vue';
import {INTERACTION_FIELDS} from '@/constants/players.js';

// @ is an alias to /src


export default {
    name: 'Home',
    data() {
        return {
            new_key: null,
            interval: null,
            cur_time: null,
            epoch: 1609459200,
           
        }
    },
    methods: {
        setKey() {
            this.$store.commit('setAuthKey', this.new_key);
        },

        updateLogs() {
            this.$store.dispatch('fetchNewLogs').then(() => {
                this.$store.dispatch('getLogs');
            });
        },

        // async getFullLog() {
        //     let done =false;
        //     let timestamp = null;
        //     while (!done) {
        //         try {
                    
        //             let selection = `?selections=log`;
        //             if (timestamp) {
        //                 selection= `${selection}&to=${timestamp}`;
        //             }
        //             let url = `https://api.torn.com/user${selection}&key=${this.existing_key}`
        //             let response = await axios.get(url)
        //             let data = response.data;
    
        //             if (!data.log) {
        //                 done= true;
        //                 break;
        //             };
    
        //             let keys = Object.keys(data.log);

        //             let logs = keys.map(key => {
        //                 data.log[key].id = key;
        //                 return data.log[key];
        //             }).sort(function (a, b) {
        //                 if (a.timestamp > b.timestamp) return -1;
        //                 if (a.timestamp < b.timestamp) return 1;
        //                 else return 0;
        //             });
        //             this.$store.dispatch('addLogs', logs);
        //             timestamp = logs[logs.length -1].timestamp;
        //             await window.sleep(500);
                    
        //         } catch(error) {
        //             console.log("ERROR", error);
        //         }
        //     }

            // this.$store.commit('setLogTimestamp', timestamp);
        // },

        fetchPlayers() {
            let players_to_fetch = [];
            this.logs.forEach(log => {
                let data = log?.data || {};
                let data_keys = Object.keys(data);
                data_keys.forEach(key => {
                    if (INTERACTION_FIELDS.includes(key)) {
                        if ( !players_to_fetch.includes(data[key])) {
                            players_to_fetch.push(data[key]);
                        }
                    }
                })
            });
            this.$store.dispatch('fetchMissingPlayers', players_to_fetch).then(() => {
                this.$store.dispatch('getLogs');
            });;
        },


        toggleSync() {
            this.$store.commit('setSyncEnabled', !this.sync_enabled);
        },

        exportData() {
            this.$store.dispatch('exportAllData');
        },

        renderData(data) {
            if (isNaN(data) || !data && data !== 0) return data;
            else if (Math.ceil(data) == data) return data.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            else return parseFloat(data).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },

        // FILTERS
        setColorFilter(event, value) {
            // console.log("setColorFilter: ", event, value);
        },
        setCategoryFilter(event, value) {
            // console.log("setCategoryFilter: ", event, value);
        },
        setLogTypeFilter(event, value) {
            // console.log("setLogTypeFilter: ", event, value);
        },
        setDateStartFilter(event, value) {
            // console.log("setDateStartFilter: ", event, value);
        },
        setDateEndFilter(event, value) {
            // console.log("setDateEndFilter: ", event, value);
        },
    },
    mounted() {
        // if (!this.interval && this.existing_key) {
        //     this.interval = setInterval(() => {
        //         if (this.sync_enabled ) {
        //             this.$store.dispatch('fetchNewLogs');
        //         }
        //     }, 60000);
        // }

       
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            // vm.$store.dispatch('getLogs');
            vm.$store.dispatch('getLogs', {
                ...toRaw(vm.$store.state.filters),
                category: null,
                player_id: null,
            });
            // vm.$store.dispatch('fetchNewLogs');
        })
    },
    computed: {
        existing_key() {
            return this.$store.state.auth.key;
        },
        logs() {
            return this.$store.getters.logs;
        },

        logs_loaded() {
            return !this.$store.state.loading.logs;
        },

        earliest_timestamp() {
            return this.$store.state.sync.earliest_timestamp;
        },

        sync_enabled() {
            return this.$store.state.sync.enabled;
        },

        total_logs() {
            return this.$store.state.stats.total_logs;
        },

        filters() {
            return this.$store.state.filters;
        },

        fetching_logs() {
            return this.$store.state.sync.fetching_logs;
        },
        
        fetching_players() {
            return this.$store.state.sync.fetching_players;
        },
    },

    watch: {
        filters:{
            deep: true,
            handler: function() {
                if (this.$store.state.navigation.screen === 'Home') {
                    // console.log("FILTERS CHANGED", this.filters);
                    this.$store.dispatch('getLogs');
                }
            }
        },
    }
}
</script>
<style lang="scss">
    #dashboard-view {

    }

    #key-input-bar {
        display: flex;
        flex-direction: row;
        align-items: center;
    }


    select {
        max-width: 150px;
    }



</style>